// TODO - ask backend for this feature..
// const user = () => JSON.parse(localStorage.getItem('user-prays'))
// export const getUserLoggedin = (state) => state.userLoggedin != null ? state.userLoggedin : user()

export const isLoggedin = (state) => !!state.userLoggedin;
export const getUserLoggedin = (state) => state.userLoggedin;
export const getAnalyitcsData = (state) => state.analytics;
export const getKeys = (state) => state.keys;